import CatalogModel from 'bundles/catalogP/models/catalogModel';

const OnDemandSessionMembership = CatalogModel.extend({
  resourceName: 'onDemandSessionMemberships.v1',
});

export default OnDemandSessionMembership;
